import styled from "styled-components";
import { ColorVariables } from "../Colors";

const StyledChangelogPage = styled.div`
  width: 100%;
  display: flex;
  background: ${ColorVariables.background};
  flex-direction: column;
  line-height: 1.25;
  h1 {
    font-size: 24px;
  }
  p {
    font-size: 16px;
  }
  ul {
    margin-top: 16px;
    max-width: 540px;
  }

  li {
    color: ${ColorVariables.coco7};
  }

  h4 {
    margin-top: 30px;
    font-size: 18px;
    font-weight: 500;
  }
`;

const Changelog = ({ notes }) => {
  return (
    <StyledChangelogPage>
      <h1>Manifest Changelog</h1>
      <p>Track changes to Manifest products</p>
      {notes.map((note) => (
        <div key={note.version}>
          <h4>{note.date}</h4>
          <ul>
            {note.changes.map((change) => (
              <li key={change}>{change}</li>
            ))}
          </ul>
        </div>
      ))}
    </StyledChangelogPage>
  );
};

export default Changelog;
